import { render, staticRenderFns } from "./CategoryMenuGroupCard.vue?vue&type=template&id=1557fc75&scoped=true"
import script from "./CategoryMenuGroupCard.vue?vue&type=script&lang=js"
export * from "./CategoryMenuGroupCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuGroupCard.vue?vue&type=style&index=0&id=1557fc75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557fc75",
  null
  
)

export default component.exports